export default {
  ANONYMOUS: 0,
  CUSTOMER: 100,
  MODERATOR: 200,
  ADMIN: 300
}
